var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"line-clamp tw-text-tsblack"},[_vm._v("\n  "+_vm._s(_vm.excerpt)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }